export const ROUTE_BASE_DOMAIN = process.env.REACT_APP_WEB_DOMAIN;

//#region 権限系ルート
export const PAGE_LOGIN = "login";
export const ROUTE_LOGIN = "/login";

//Account
export const PREFIX_ROUTE_ACCOUNT = "/account/";
export const PAGE_ACCOUNT_CREATE = "create";
export const ROUTE_ACCOUNT_CREATE = `${PREFIX_ROUTE_ACCOUNT}${PAGE_ACCOUNT_CREATE}`;
export const PAGE_ADMIN_ACCOUNTS = "admins";
export const ROUTE_ADMIN_ACCOUNTS = `${PREFIX_ROUTE_ACCOUNT}${PAGE_ADMIN_ACCOUNTS}`;

//Auth
export const PREFIX_ROUTE_AUTH = "/auth/";
export const PAGE_NOT_ALLOWED = "notAllowed";
export const ROUTE_NOT_ALLOWED = `${PREFIX_ROUTE_AUTH}${PAGE_NOT_ALLOWED}`;
export const PAGE_NOT_FOUND = "notFound";
export const ROUTE_NOT_FOUND = `${PREFIX_ROUTE_AUTH}${PAGE_NOT_FOUND}`;
export const PAGE_SERVER_ERROR = "error";
export const ROUTE_SERVER_ERROR = `${PREFIX_ROUTE_AUTH}${PAGE_SERVER_ERROR}`;

//Management
export const PREFIX_ROUTE_ADMIN = "/management/";
export const PAGE_ADMIN_DASHBOARD = "dashboard";
export const ROUTE_ADMIN_DASHBOARD = `${PREFIX_ROUTE_ADMIN}${PAGE_ADMIN_DASHBOARD}`;
export const PAGE_MONTHLY_REPORTS = "locked-reports";
export const ROUTE_MONTHLY_REPORTS = `${PREFIX_ROUTE_ADMIN}${PAGE_MONTHLY_REPORTS}`;
export const PAGE_PROFIT_LOSS_CALCULATE = "calculate";
export const ROUTE_PROFIT_LOSS_CALCULATE = `${PREFIX_ROUTE_ADMIN}${PAGE_PROFIT_LOSS_CALCULATE}`;
export const PAGE_POSTED_LINKS = "social-links";
export const ROUTE_POSTED_LINKS = `${PREFIX_ROUTE_ADMIN}${PAGE_POSTED_LINKS}`;
export const PAGE_PRINT_PDF = "print";
export const ROUTE_PRINT_PDF = `${PREFIX_ROUTE_ADMIN}${PAGE_PRINT_PDF}`;
export const PAGE_INSTOCK_LIST = "instock-list";
export const ROUTE_INSTOCK_LIST = `${PREFIX_ROUTE_ADMIN}${PAGE_INSTOCK_LIST}`;

//Shop
export const PREFIX_ROUTE_SHOP = "/shop/";
export const PAGE_SHOP_LIST = "list";
export const ROUTE_SHOP_LIST = `${PREFIX_ROUTE_SHOP}${PAGE_SHOP_LIST}`;
export const PAGE_ADD_SHOP = "add";
export const ROUTE_ADD_SHOP = `${PREFIX_ROUTE_SHOP}${PAGE_ADD_SHOP}`;

//Category
export const PREFIX_ROUTE_CATEGORY = "/category/";
export const PAGE_CATEGORY_CREATE = "create";
export const ROUTE_CATEGORY_CREATE = `${PREFIX_ROUTE_CATEGORY}${PAGE_CATEGORY_CREATE}`;
export const PAGE_CATEGORY_LIST = "list";
export const ROUTE_CATEGORY_LIST = `${PREFIX_ROUTE_CATEGORY}${PAGE_CATEGORY_LIST}`;

//Product
export const PREFIX_ROUTE_PRODUCT = "/product/";
export const PAGE_PRODUCT_LIST = "list";
export const ROUTE_PRODUCT_LIST = `${PREFIX_ROUTE_PRODUCT}${PAGE_PRODUCT_LIST}`;
export const PAGE_PRODUCT_CREATE = "create";
export const ROUTE_PRODUCT_CREATE = `${PREFIX_ROUTE_PRODUCT}${PAGE_PRODUCT_CREATE}`;
export const PAGE_PRODUCT_EDIT = "edit";
export const ROUTE_PRODUCT_EDIT = `${PREFIX_ROUTE_PRODUCT}${PAGE_PRODUCT_EDIT}`;
export const PAGE_PRODUCT_DETAILS = "details";
export const ROUTE_PRODUCT_DETAILS = `${PREFIX_ROUTE_PRODUCT}${PAGE_PRODUCT_DETAILS}`;

//Purchase
export const PREFIX_ROUTE_PURCHASE = "/purchase/";
export const PAGE_PURCHASE_LIST = "list";
export const ROUTE_PURCHASE_LIST = `${PREFIX_ROUTE_PURCHASE}${PAGE_PURCHASE_LIST}`;
export const PAGE_PURCHASE_PRODUCT = "product";
export const ROUTE_PURCHASE_PRODUCT = `${PREFIX_ROUTE_PURCHASE}${PAGE_PURCHASE_PRODUCT}`;
export const PAGE_PURCHASE_EDIT = "edit";
export const ROUTE_PURCHASE_EDIT = `${PREFIX_ROUTE_PURCHASE}${PAGE_PURCHASE_EDIT}`;
export const PAGE_PURCHASE_DETAILS = "details";
export const ROUTE_PURCHASE_DETAILS = `${PREFIX_ROUTE_PURCHASE}${PAGE_PURCHASE_DETAILS}`;

//Order
export const PREFIX_ROUTE_ORDER = "/order/";
export const PAGE_ORDER_CREATE = "create";
export const ROUTE_ORDER_CREATE = `${PREFIX_ROUTE_ORDER}${PAGE_ORDER_CREATE}`;
export const PAGE_ORDER_DETAILS = "details";
export const ROUTE_ORDER_DETAILS = `${PREFIX_ROUTE_ORDER}${PAGE_ORDER_DETAILS}`;
export const PAGE_ORDER_DELI_EDIT = "deli-edit";
export const ROUTE_ORDER_DELI_EDIT = `${PREFIX_ROUTE_ORDER}${PAGE_ORDER_DELI_EDIT}`;
export const PAGE_ORDER_EDIT = "edit";
export const ROUTE_ORDER_EDIT= `${PREFIX_ROUTE_ORDER}${PAGE_ORDER_EDIT}`;
export const PAGE_ORDER_LIST = "list";
export const ROUTE_ORDER_LIST= `${PREFIX_ROUTE_ORDER}${PAGE_ORDER_LIST}`;

//General Expend
export const PREFIX_ROUTE_GENERAL_EXPEND = "/expend/";
export const PAGE_GENERAL_EXPEND_LIST = "list";
export const ROUTE_GENERAL_EXPEND_LIST = `${PREFIX_ROUTE_GENERAL_EXPEND}${PAGE_GENERAL_EXPEND_LIST}`;
export const PAGE_ADD_GENERAL_EXPEND = "add";
export const ROUTE_ADD_GENERAL_EXPEND = `${PREFIX_ROUTE_GENERAL_EXPEND}${PAGE_ADD_GENERAL_EXPEND}`;
export const PAGE_GENERAL_EXPEND_DETAILS = "details";
export const ROUTE_GENERAL_EXPEND_DETAILS = `${PREFIX_ROUTE_GENERAL_EXPEND}${PAGE_GENERAL_EXPEND_DETAILS}`;
export const PAGE_EDIT_GENERAL_EXPEND = "edit";
export const ROUTE_EDIT_GENERAL_EXPEND = `${PREFIX_ROUTE_GENERAL_EXPEND}${PAGE_EDIT_GENERAL_EXPEND}`;

//Money Adjustment
export const PREFIX_ROUTE_MONEY_ADJUSTMENT = "/money-adjustment/";
export const PAGE_MONEY_ADJUSTMENT_LIST = "list";
export const ROUTE_MONEY_ADJUSTMENT_LIST = `${PREFIX_ROUTE_MONEY_ADJUSTMENT}${PAGE_MONEY_ADJUSTMENT_LIST}`;
export const PAGE_ADD_MONEY_ADJUSTMENT = "add";
export const ROUTE_ADD_MONEY_ADJUSTMENT = `${PREFIX_ROUTE_MONEY_ADJUSTMENT}${PAGE_ADD_MONEY_ADJUSTMENT}`;
export const PAGE_MONEY_ADJUSTMENT_DETAILS = "details";
export const ROUTE_MONEY_ADJUSTMENT_DETAILS = `${PREFIX_ROUTE_MONEY_ADJUSTMENT}${PAGE_MONEY_ADJUSTMENT_DETAILS}`;
export const PAGE_EDIT_MONEY_ADJUSTMENT = "edit";
export const ROUTE_EDIT_MONEY_ADJUSTMENT = `${PREFIX_ROUTE_MONEY_ADJUSTMENT}${PAGE_EDIT_MONEY_ADJUSTMENT}`;

//Instock Adjustment
export const PREFIX_ROUTE_INSTOCK_ADJUSTMENT = "/stock/";
export const PAGE_OUTOFSTOCKS = "out-of-stocks";
export const ROUTE_OUTOFSTOCKS = `${PREFIX_ROUTE_INSTOCK_ADJUSTMENT}${PAGE_OUTOFSTOCKS}`;
export const PAGE_INSTOCKS = "in-stocks";
export const ROUTE_INSTOCKS = `${PREFIX_ROUTE_INSTOCK_ADJUSTMENT}${PAGE_INSTOCKS}`;
export const PAGE_SEND_STOCK_HISTORIES = "send-stock-histories";
export const ROUTE_SEND_STOCK_HISTORIES = `${PREFIX_ROUTE_INSTOCK_ADJUSTMENT}${PAGE_SEND_STOCK_HISTORIES}`;

//#endregion

export const ROUTE_Home = "/home";